<template>
  <div class="bpm-viewer">
    <viewer :images="imgList">
      <slot :list="imgList" @click="show">
        <img v-for="src in imgList" :key="src" class="viewer-img" :src="src">
      </slot>
    </viewer>
  </div>
</template>

<script>
export default {
  name: 'ImgViewer',
  props: {
    imgList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    show() {
      this.$viewerApi({
        images: this.imgList
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .bpm-viewer {
    .viewer-img {
      width: 50px;
      height: auto;
      margin-right: 8px;
      border-radius: 4px;
      cursor: pointer;
      margin-bottom: 10px;
    }
  }
</style>
